import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Displays a single regulation badge for product cards (shipping / prescription / click & collect).
 * Styled to match the site: fully-rounded pill with a small status dot, soft
 * tinted background + border.
 */
const ProductRegulationBadge = ({ regulations, className = '' }) => {
  const { t } = useLanguage();

  if (!regulations || !Array.isArray(regulations) || regulations.length === 0) {
    return null;
  }

  const codeId = regulations[0]?.code?.id;
  if (!codeId) return null;

  const config = {
    'Sale.Web.Rx': {
      labelKey: 'regulation.prescriptionRequired',
      className: 'bg-red-50 border border-red-100 text-red-700',
      dotClass: 'bg-red-500',
    },
    'Sale.Web.CC': {
      labelKey: 'regulation.clickAndCollect',
      className: 'bg-indigo-50 border border-indigo-100 text-indigo-700',
      dotClass: 'bg-indigo-500',
    },
    'Sale.Web.OK': {
      labelKey: 'regulation.shippingPossible',
      className: 'bg-emerald-50 border border-emerald-100 text-emerald-700',
      dotClass: 'bg-emerald-500',
    },
  };

  const item = config[codeId];
  if (!item) return null;

  return (
    <div className={`flex items-center justify-between ${className}`}>
      <span
        className={`inline-flex max-w-full items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium tracking-tight whitespace-nowrap transition-colors duration-200 sm:gap-1.5 sm:px-2.5 sm:py-1 sm:text-[11px] ${item.className}`}
        role="status"
        aria-label={t(item.labelKey)}
      >
        <span className={`h-1.5 w-1.5 flex-shrink-0 rounded-full ${item.dotClass}`} aria-hidden="true" />
        <span className="truncate">{t(item.labelKey)}</span>
      </span>
    </div>
  );
};

export default ProductRegulationBadge;
